import { useEffect, useRef } from 'react';
import { WebAnalytics } from '@/lib/analytics';
import { EVENT_HOTEL_WIDGET_SHOWN } from '@/lib/analyticsEvents';
import type { HotelWidgetShownAnalyticsProps } from '@/lib/analyticsAttribution';

/**
 * Fires Hotel Widget Shown once per mount when `enabled` is true.
 * Mirrors Experience Widget Shown (GYG mount) for hotel booking CTA impressions.
 */
export function useTrackHotelWidgetShown(
  enabled: boolean,
  props: HotelWidgetShownAnalyticsProps | null | undefined,
): void {
  const trackedRef = useRef(false);

  const surface = props?.surface;
  const ctaType = props?.cta_type;
  const userId = props?.user_id;
  const postId = props?.post_id;
  const placeId = props?.place_id;
  const googlePlaceId = props?.google_place_id;
  const locationName = props?.location_name;
  const contentType = props?.content_type;

  useEffect(() => {
    if (!enabled || !surface || !ctaType) {
      return;
    }
    if (trackedRef.current) {
      return;
    }
    trackedRef.current = true;

    WebAnalytics.track(EVENT_HOTEL_WIDGET_SHOWN, {
      surface,
      cta_type: ctaType,
      vendor: 'gt_stay',
      ...(userId && { user_id: userId }),
      ...(postId && { post_id: postId }),
      ...(placeId && { place_id: placeId }),
      ...(googlePlaceId && { google_place_id: googlePlaceId }),
      ...(locationName && { location_name: locationName }),
      ...(contentType && { content_type: contentType }),
      ...WebAnalytics.getReferringCreatorProps(),
    });
  }, [
    enabled,
    surface,
    ctaType,
    userId,
    postId,
    placeId,
    googlePlaceId,
    locationName,
    contentType,
  ]);
}
